/*!
=========================================================
* Painel Toca da Onça — Login
=========================================================
* Proteção simples por PIN (client-side). Troca de PIN: editar PIN_MESTRE.
*/
import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "assets/img/logo-toca.png";

const PIN_MESTRE = "2026";
const VENDEDORES = { ana: "1111", bia: "2222", carla: "3333" };

function Login() {
  const nav = useNavigate();
  const [usuario, setUsuario] = React.useState("");
  const [pin, setPin] = React.useState("");
  const [erro, setErro] = React.useState("");

  const entrar = (e) => {
    e.preventDefault();
    const u = usuario.trim().toLowerCase();
    const ok =
      (pin === PIN_MESTRE && (u === "" || u === "carlos" || u === "mestre" || u === "dono")) ||
      (VENDEDORES[u] && VENDEDORES[u] === pin);
    if (!ok) {
      setErro("Usuário ou PIN incorreto.");
      return;
    }
    localStorage.setItem("toca_auth", JSON.stringify({ usuario: u || "carlos", ts: Date.now() }));
    nav("/admin/cerebro", { replace: true });
  };

  return (
    <div style={{ minHeight: "100vh", background: "radial-gradient(700px 500px at 50% 20%, #1a1508 0%, #070707 65%)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <form onSubmit={entrar} style={{ width: "100%", maxWidth: 380, background: "#101010", border: "1px solid rgba(255,215,0,.3)", borderRadius: 18, padding: "34px 30px", textAlign: "center", boxShadow: "0 0 60px rgba(255,215,0,.08)" }}>
        <img src={logo} alt="Toca da Onça" style={{ width: 110, height: 110, borderRadius: "50%", marginBottom: 14 }} />
        <h2 style={{ color: "#ffd700", letterSpacing: 3, fontWeight: 700, margin: 0, fontSize: 22 }}>TOCA DA ONÇA</h2>
        <p style={{ color: "#8a8a8a", letterSpacing: 4, fontSize: 11, margin: "2px 0 24px" }}>CENTRAL DE COMANDO</p>

        <input
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          placeholder="Usuário (carlos, ana, bia, carla)"
          style={{ width: "100%", padding: "13px 16px", borderRadius: 10, border: "1px solid #2c2c2c", background: "#181818", color: "#fff", marginBottom: 12, fontSize: 15, outline: "none" }}
        />
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="PIN"
          type="password"
          inputMode="numeric"
          style={{ width: "100%", padding: "13px 16px", borderRadius: 10, border: "1px solid #2c2c2c", background: "#181818", color: "#fff", marginBottom: 14, fontSize: 15, outline: "none", letterSpacing: 6, textAlign: "center" }}
        />
        {erro && <p style={{ color: "#ff6b6b", fontSize: 13, margin: "0 0 10px" }}>{erro}</p>}
        <button type="submit" style={{ width: "100%", padding: 14, borderRadius: 10, border: "none", background: "linear-gradient(90deg,#ffd700,#d4a017)", color: "#111", fontWeight: 700, fontSize: 15, letterSpacing: 1, cursor: "pointer" }}>
          ENTRAR
        </button>
        <p style={{ color: "#6a6a6a", fontSize: 11, marginTop: 16 }}>Acesso restrito · Toca da Onça Modas 🐆</p>
      </form>
    </div>
  );
}

export default Login;
